import React, { Fragment, useEffect } from "react";
import { ResponsiveHeader } from "pages/_components/header";
import { useSelector, useDispatch } from "react-redux";
import { push } from "connected-react-router";
import { useParams } from "react-router-dom";
import Button from "pages/_components/Button";
import MainContainer from "pages/_components/MainContainer";
import { actions as debinActions } from "reducers/debin";
import { actions as accountsActions } from "reducers/accounts";
import Loader from "pages/_components/Loader";
import Notification from "pages/_components/Notification";
import { statusTagColor } from "util/debin";
import { Col, Row } from "react-bootstrap";
import DataDataIssuedDebin from "./_components/DataDataIssuedDebin";
import InfoTag from "../_components/InfoTag";

const DetailIssuedDebin = ({ isDesktop }) => {
    const { fetching, sentRequests, debinDetail } = useSelector((state) => state.debin);
    const { accounts } = useSelector((state) => state.accounts);
    const { id } = useParams();
    const dispatch = useDispatch();
    const receivedDebin = sentRequests?.debinList?.find((object) => object.id === id);
    const accountseller = accounts?.find((object) => object?.cbu?.substring(9) === receivedDebin?.seller?.cbu);
    const creditAccountMask = `****${accountseller?.shortLabel?.substring(1)}`;
    const debitAccountMask = receivedDebin?.buyer?.cbu?.substring(9, 21);
    useEffect(() => {
        dispatch(debinActions.getDebinDetail(id));
    }, [sentRequests]);
    useEffect(() => {
        dispatch(accountsActions.listAccountsCbu());
    }, []);

    if (fetching) {
        return <Loader />;
    }

    const State = () => (
        <InfoTag
            type="info"
            message={receivedDebin?.status?.code}
            tagBackground={statusTagColor(receivedDebin?.status?.code)}
        />
    );

    const buttons = () => (
        <>
            {receivedDebin?.status?.code === "INICIADO" && (
                <Row className="pb-9">
                    <Col xs={12} md={5} mdOffset={4}>
                        <Button
                            className="btn btn-primary"
                            label="debin.anulate.debin"
                            onClick={() => {
                                dispatch(debinActions.getDebinDetail(receivedDebin.id));
                                dispatch(push("/debinPayments/action/anulate"));
                            }}
                        />
                    </Col>
                </Row>
            )}
        </>
    );
    return (
        <Fragment>
            <Notification scopeToShow="debinPayments" />
            <ResponsiveHeader
                id="debin.generated.detail.title"
                backLinkTo="/debinPayments"
                infoComponents={
                    isDesktop && (
                        <div className="pl-4">
                            <State />
                        </div>
                    )
                }
            />
            <MainContainer showLoader={fetching}>
                <DataDataIssuedDebin
                    debitAccountMask={debitAccountMask || "-"}
                    buyerName={debinDetail?.buyerDetail?.titular || "-"}
                    buyerCuit={
                        `${debinDetail?.buyerDetail?.documentType} ${debinDetail?.buyerDetail?.documentNumber}` || "-"
                    }
                    curency={debinDetail?.amount?.currency || "-"}
                    amount={debinDetail?.amount?.quantity || "-"}
                    solicitDate={debinDetail?.creationDate || "-"}
                    dueDate={debinDetail?.expirationDate || "-"}
                    debinId={debinDetail?.id || "-"}
                    buyerCbu={debinDetail?.buyerDetail?.cbu || "-"}
                    alias={debinDetail?.buyerDetail?.cbuAlias || "-"}
                    bank={debinDetail?.buyerDetail?.bank || "-"}
                    concept={debinDetail?.concept || "-"}
                    description={debinDetail?.description || "-"}
                    reference={debinDetail?.reference || "-"}
                    creditAccount={creditAccountMask || "-"}
                    voucher={debinDetail?.idVoucher || "-"}
                    isDesktop={isDesktop}
                />
                {buttons()}
            </MainContainer>
        </Fragment>
    );
};

export default DetailIssuedDebin;
